import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const SignInContainer = styled.div`
  display: none;
  align-items: center;
  gap: 0.5rem;

  ${media.md`
    display: flex;
  `}
`;
